import { render, staticRenderFns } from "./detailsTable.vue?vue&type=template&id=d914839e&scoped=true&slot-scope=scope&"
import script from "./detailsTable.vue?vue&type=script&lang=js&"
export * from "./detailsTable.vue?vue&type=script&lang=js&"
import style0 from "./detailsTable.vue?vue&type=style&index=0&id=d914839e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d914839e",
  null
  
)

export default component.exports